import BankAccount from 'app/models/bank_account';
import CreditCard from 'app/models/credit_card';

import Base from 'app/models/base';

import { appUrl } from 'utils/wrappers';

export default Base.extend({
  url: appUrl('payment_methods'),

  parse(res) {
    const response = { ...res };

    const modelizeRawPaymentMethod = raw => {
      if (raw) {
        let model;
        if (raw.object === 'CreditCard') {
          model = new CreditCard(raw);
        } else if (raw.object === 'BankAccount') {
          model = new BankAccount(raw);
        }
        if (model) {
          this.listenTo(model, 'charge', () => this.trigger('charge'));
          return model;
        }
      }
      return undefined;
    };

    response.primary_payment_method = modelizeRawPaymentMethod(response.primary_payment_method);
    response.secondary_payment_method = modelizeRawPaymentMethod(response.secondary_payment_method);
    return response;
  },

  primary() {
    return this.get('primary_payment_method');
  },

  secondary() {
    return this.get('secondary_payment_method');
  },

  hasAPaymentMethod() {
    return !!(this.primary() || this.secondary());
  },
});



// WEBPACK FOOTER //
// ./app/models/payment_methods.js